import React from 'react'
import { useParams } from 'react-router'

// mui
import { Grid, Container, Typography } from '@mui/material'

// collections
import ItemsForRequest from './collections/ItemsForRequest/ItemsForRequest.collection'
import RequestInfo from './collections/RequestInfo/RequestInfo.collection'

export default function RequestDetails() {
  const { requestId } = useParams()

  // ✅ Convert once
  const requestIdInt = parseInt(requestId, 10)

  return (
    <div>
      <Container disableGutters sx={{ marginBottom: 4 }}>
        <Grid container>
          <Grid item>
            <Typography variant="h2">Equipment Request</Typography>
          </Grid>
        </Grid>
      </Container>

      <RequestInfo requestId={requestIdInt} />

      <Typography variant="h4">Equipment</Typography>
      <ItemsForRequest requestId={requestIdInt} />
    </div>
  )
}

